module.exports = __webpack_public_path__ + "static/img/application-bg.1da1146.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/city-agent/application-bg.png
// module id = 8wcp
// module chunks = 4